import * as React from 'react';
import * as Dictionary from '../../../Models/Dictionary';
import * as UserModule from '../../../Modules/UserModule';
import * as ViewManagementModule from '../../../Modules/ViewManagementModule';
import {EnumTypes as PageEnumTypes} from '../../../Models/EnumTypes/PageEnumTypes';
import {connect} from 'react-redux';
import SingleMenuItem from '../SingleMenuItem/SingleMenuItem';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

export type State = {};

export type Props = {};

export type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

export type DispatchedProps = {
    toggleMenu: () => void;
};

class MenuSidebar extends React.Component<Props & DispatchedProps & ConnectedProps, State> {
    constructor(props: Props & DispatchedProps & ConnectedProps) {
        super(props);
    }

    public render() {
        const {userStore} = this.props;
        const {sidebarMenuExpanded} = this.props.viewManagementStore;
        const {ADMIN, EXTERNAL} = UserModule.UserEnumTypes.RoleName;
        return (
            <div
                className={`sidebar menu-left ${this.props.viewManagementStore.sidebarMenuExpanded ? 'menu-left--expanded' : ''}`}>
                <div className="menu-left__toggle" onClick={() => this.props.toggleMenu()}>
                    <img className="menu-left__icon-dropdown" src={'/images/icons/dropdown.svg'}/>
                    <img
                        className={`menu-left__icon-arrow ${sidebarMenuExpanded && 'menu-left__icon-arrow--opened'}`}
                        src={'/images/icons/arrow_left.svg'} height={10}/>
                </div>

                <ul className="mb-50">
                    {userStore.user?.roleName !== EXTERNAL && Dictionary.MainMenu.map((menuItem: PageEnumTypes.Page, i: number) => {
                        const menuDetails = Dictionary.PageDetails.get(menuItem);
                        return <SingleMenuItem page={menuDetails} key={i}/>;
                    })}
                    {userStore.user && userStore.user.roleName === ADMIN &&
                    Dictionary.AdminMenu.map((menuItem: PageEnumTypes.Page, i: number) => {
                        const menuDetails = Dictionary.PageDetails.get(menuItem);
                        return <SingleMenuItem page={menuDetails} key={i}/>;
                    })}
                    {userStore.user?.roleName === EXTERNAL &&
                    Dictionary.ExternalMenu.map((menuItem: PageEnumTypes.Page, i: number) => {
                        const menuDetails = Dictionary.PageDetails.get(menuItem);
                        return <SingleMenuItem page={menuDetails} key={i}/>;
                    })}
                </ul>

                <ul>
                    {userStore.user && userStore.user.roleName === ADMIN &&
                    Dictionary.ReportMenu.map((menuItem: PageEnumTypes.Page, i: number) => {
                        const menuDetails = Dictionary.PageDetails.get(menuItem);
                        return <SingleMenuItem page={menuDetails} key={i}/>;
                    })}
                </ul>

                <div className="menu-left__lang">
                    <ul>
                        {Dictionary.BottomMenu.map((menuItem: PageEnumTypes.Page, i: number) => {
                            const menuDetails = Dictionary.PageDetails.get(menuItem);
                            if (menuDetails !== undefined && menuDetails.title !== PageEnumTypes.Page.LANGUAGES) {
                                return <SingleMenuItem page={menuDetails} key={i}/>;
                            } else if (menuDetails !== undefined && menuDetails.title == PageEnumTypes.Page.LANGUAGES) {
                                return <LanguageSwitcher key={i}/>;
                            } else {
                                return null;
                            }
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userStore: state.userStore,
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any) {
    return {
        toggleMenu: () => dispatch(ViewManagementModule.Actions.toggleSidebarMenu()),
        toggleDetailsPanel: () => dispatch(ViewManagementModule.Actions.toggleDetailsPanel())
    };
}

/**
 * Komponent wysuwanego głównego menu aplikacji
 */
export default connect<{}, {}, Props>(
    mapStateToProps,
    mapDispachToProps
)(MenuSidebar) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Layout/MenuSidebar/MenuSidebar.tsx